import { render, staticRenderFns } from "./OneTimeDiscountTabs.vue?vue&type=template&id=0c6fb22e&scoped=true"
import script from "./OneTimeDiscountTabs.vue?vue&type=script&lang=js"
export * from "./OneTimeDiscountTabs.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./OneTimeDiscountTabs.vue?vue&type=style&index=1&id=0c6fb22e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6fb22e",
  null
  
)

export default component.exports